import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Typography from '../typography';

interface CircleTextProps {
  className?: string;
}

const CircleText: FunctionComponent<CircleTextProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <CircleWrapper className={className || ''} {...props}>
      <Typography weight="700" type="smaller">
        {children}
      </Typography>
    </CircleWrapper>
  );
};

export default CircleText;

const CircleWrapper = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  width: 24px;
  height: 24px;
`;
